module.exports = __webpack_public_path__ + "img/T5-B-xh18.4ce9fbad.png";